import academia1 from "../../img/academia/academia1.webp"
import academia2 from "../../img/academia/academia2.webp"
import academia3 from "../../img/academia/academia3.webp"


const datePlans = [
    {id: 1, img: academia1, alt: "Imagem de uma pessoa malhando na academia", title: "Plano Básico", description: "Acesso à academia em horários de menor movimento.", price: "R$ 99,90/mês"},
    {id: 2, img: academia2, alt: "Imagem de uma pessoa malhando na academia", title: "Plano Intermediário", description: "Acesso à academia em todos os horários e aulas em grupo.", price: "R$ 149,90/mês"},
    {id: 3, img: academia3, alt: "Imagem de uma pessoa malhando na academia", title: "Plano Premium", description: "Acesso total à academia, aulas em grupo  e personal trainer.", price: "R$ 199,90/mês"},
]

export default datePlans;